import React from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faPencilAlt,
  faPlus,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import useCopyToClipboard from "../../../../../_hooks/useCopyToClipboard";
import ShareLink from "../../../../../_uiComponents/ShareLink";
import { appRoutes } from "../../../../../_routes/app-routes";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    eventsLoading,
    calendarEventLists,
    onScrollEvents,
    eventsRef,
    onEventDeleteClick,
    onEventEditClick,
    calendarEventListsData,
    onCreateEventClick,
  } = props;

  const { getWebUrl , copyToClipboard} = useCopyToClipboard();

  return (
    <>
      <div className="event-list p-4 bg-white border border-radius-10">
        <div className="d-flex align-items-start justify-content-between">
          <div className="d-flex align-items-center mb-4">
            <div className="top-filter">
              <h2 className="mb-2">My Events </h2>
            </div>
          </div>
          <button
            className="btn btn-primary border-radius-10"
            onClick={onCreateEventClick}
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2" />
            New Event
          </button>
        </div>
        {Array.isArray(calendarEventLists) && calendarEventLists.length > 0 ? (
          <div
            className="row"
            onScroll={onScrollEvents}
            ref={eventsRef}
            style={{ height: "100%", overflowY: "auto" }}
          >
            {Array.isArray(calendarEventLists) &&
              calendarEventLists.map((item) => (
                <div className="col-md-6 col-xl-4 mt-4" key={item?.id}>
                  <div className="event-box  h-100 d-flex flex-column  mb-2 bg-white p-3 border border-radius-10">
                    <div className="flex-grow-1">
                      <div className="event-box-header d-flex align-items-center justify-content-between">
                        <h3 className="font-weight-semi mb-2 text-primary">
                          {item?.title}
                        </h3>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant=""
                            id="dropdown-basic"
                            className="no-dropdown-arrow mt-0"
                          >
                            <FontAwesomeIcon icon={faEllipsisVertical} />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => onEventEditClick(item?.id)}
                            >
                              <FontAwesomeIcon
                                icon={faPencilAlt}
                                className="text-grey-4 mr-2"
                              />
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => onEventDeleteClick(item?.id)}
                            >
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                className="text-danger mr-2"
                              />
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className="content pb-3">
                        <p className="text-grey-4">{item?.duration} Mins</p>
                        <div
                          className="text-grey-4"
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        ></div>
                      </div>
                    </div>
                    {!item?.hash_id ? (
                      <div className="d-flex align-items-center border-top mt-3 pt-2 justify-content-between mt-auto">
                        <p className="text-grey-4 text-danger">
                          Availability is Not set
                        </p>
                        <button
                          className="btn btn-primary ml-2 py-1 fs-smallest"
                          onClick={() => onEventEditClick(item?.id)}
                        >
                          Set Availability
                        </button>
                      </div>
                    ) : (
                      <div className="mt-3 d-flex align-items-center flex-wrap pt-2 border-top mt-auto text-right">
                        <button className="share-icon-btn mr-2 border border-primary bg-primary text-white rounded-circle"
                         >
                          <FontAwesomeIcon
                            onClick={() => copyToClipboard(getWebUrl(), item?.hash_id)}
                            icon={faCopy}
                          />
                        </button>
                        <ShareLink
                          link={`${getWebUrl()}${appRoutes.assessementKit.scheduleEventLink}?event_link=, ${item?.hash_id}`}
                          message={`${
                            item?.event_creator && item.event_creator?.full_name
                          } 
                        invites you to jigsaw click on the link to schedule meet`}
                        />
                      </div>
                    )}{" "}
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div
            className="d-flex align-items-center
            justify-content-center flex-column py-4"
          >
            <img src="/assets/images/empty-state.svg" alt="empty" />
            <h4 className="font-weight-bold mb-1 mt-2">
              No events created. Create one from above.
            </h4>
            <p>Crete events to scheduled interviews with candidates</p>
            <Link
              to={"/create-event"}
              className="px-4 border border-primary shadow 
              text-primary py-1 rounded-lg font-weight-semi"
            >
              Create Event
            </Link>
          </div>
        )}
      </div>

      {eventsLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {!eventsLoading && (
        <div className="d-flex col-12 justify-content-center align-items-center">
          <p className="font-weight-bold mt-4">
            Showing{" "}
            {Array.isArray(calendarEventLists) &&
              calendarEventLists &&
              calendarEventLists.length}{" "}
            of{" "}
            {calendarEventListsData?.data && calendarEventListsData.data?.count}{" "}
            events
          </p>
        </div>
      )}
    </>
  );
};
